import { Popup } from '@CS/components/Popups';
import { PopupContent, Triangle, Title, Description, Button } from './AvatarCreatePopup.styles';

type AvatarCreatePopupProps = {
  onClose: () => void;
};

export const AvatarCreatePopup = ({ onClose }: AvatarCreatePopupProps) => {
  return (
    <Popup
      onClose={onClose}
      width={90}
      hideClose
      customStyle={{
        maxWidth: '295px',
        padding: '24px 20px',
        overflow: 'visible',
        top: '53%',
        left: '54%',
        minHeight: '168px',
      }}
    >
      <PopupContent>
        <Triangle />
        <Title>Maak je avatar!</Title>
        <Description>
          Maak je familie nu na in de avatar creator om te beginnen!
        </Description>
        <Button onClick={onClose}>Okay!</Button>
      </PopupContent>
    </Popup>
  );
};
